import { DefaultBtn, PrimaryBtn } from "../buttons"

interface Props {
  type?: "engagements" | "dream-rate" | "leads"
  onViewLast12Months?: () => void
  onSelectDateRange?: () => void
  children?: React.ReactNode
}

const NoResultsInRangeMessage = ({
  type,
  onViewLast12Months,
  onSelectDateRange,
  children
}: Props) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] text-center px-4">
      {children}
      <h2 className="text-xl font-bold">
        {type === "engagements"
          ? "No engagements in this date range."
          : type === "dream-rate"
          ? "No Dream Rate leads in this date range."
          : "No leads in this date range."}
      </h2>
      <p className="mt-2 max-w-sm">
        {type === "engagements"
          ? "Update the date range filters to view your engagements."
          : "Update the date range filters to view your leads."}
      </p>
      {(onViewLast12Months || onSelectDateRange) && (
        <div className="mt-8 flex flex-col sm:flex-row gap-4 items-center justify-center">
          {onViewLast12Months && (
            <PrimaryBtn onClick={onViewLast12Months}>
              View last 12 months
            </PrimaryBtn>
          )}
          {onViewLast12Months && onSelectDateRange && <span>or</span>}

          {onSelectDateRange && (
            <DefaultBtn onClick={onSelectDateRange}>
              Select Date Range
            </DefaultBtn>
          )}
        </div>
      )}
    </div>
  )
}

export default NoResultsInRangeMessage
